import React from "react";
import "./deleteModal.css";

const ProductDeleteModal = ({ handleModal, handleDelete }) => {
    return (
        <>
            <div className="popup-modal">
                <div className="popup-modal-content">
                    <h4 className="content text-lg font-bold">Are you sure ? You want to delete this.</h4>
                    <p className="content text-gray-600">
                        This action cannot be undone. All associated <strong>variables and add-ons</strong> will also be permanently removed.
                    </p>
                    <div className="popup_btn_container">
                        <button
                            className="btn btn-primary me-2"
                            onClick={(e) => {
                                e.preventDefault();
                                handleDelete();
                            }}
                        >
                            Yes
                        </button>
                        <button
                            className="btn btn btn-secondary"
                            onClick={() => handleModal(false)}
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductDeleteModal;
